import React from 'react';
// Reach
import { ListboxInput, ListboxButton, ListboxPopover, ListboxList, ListboxOption } from '@reach/listbox';
// Modules
import classNames from 'classnames/bind';
// Interfaces
import { CoreProps } from '../types';
import { IconsEnum } from '@utmb/types/icons';
// Design system
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
// Styles
import styles from './select.module.scss';
import '@reach/listbox/styles.css';

const cx = classNames.bind(styles);

export const SELECT_DEFAULT_VALUE = 'default';

interface SelectProps {
    id: string;
    name: string;
    label?: string;
    firstOptionlabel?: string;
    defaultValue?: string;
    value: string;
    onchange?: any;
    require?: boolean;
}

export const Select = (props: SelectProps & CoreProps) => {
    const { id, label, firstOptionlabel, children, onchange, value, require } = props;

    const containerCSS = cx(styles.select, { default: value === '' });

    return (
        <>
            <Font.OxaniumRegular as="span" mobile="12" desktop="12" className={styles.label}>
                {label}
                {require ? ' *' : ''}
            </Font.OxaniumRegular>

            <ListboxInput
                className={containerCSS}
                aria-labelledby={id}
                id={id}
                defaultValue={value || SELECT_DEFAULT_VALUE}
                // value={value}
                onChange={onchange}
            >
                <ListboxButton arrow={<Icon clss={styles.icon} variant={IconsEnum.CHEVRON_DOWN} />} />
                <ListboxPopover id={'listbox-popover'} portal={false}>
                    <ListboxList className={styles.listbox_list}>
                        <ListboxOption value={SELECT_DEFAULT_VALUE}>
                            <Font.FuturaBook as="span" mobile="14" desktop="16">
                                {firstOptionlabel || label}
                            </Font.FuturaBook>
                        </ListboxOption>
                        {children}
                    </ListboxList>
                </ListboxPopover>
            </ListboxInput>
        </>
    );
};
